import _ from "lodash";
import { BAA_COUNTRIES, BASE_PLAN_SUB_TYPES, planTypes } from '@/common/constants';
import { enableCAICPlanRebranding } from '@/plans/ZOOM_CUSTOM_AI_COMPANION/utils.js';
/**
 *
 * @param {*} type
 * @param {*} subType
 * @param {*} isSDK The base plan is video sdk
 * @param options
 * @returns
 */
export function getPlanTypeName(type, subType = '', isSDK = false, options = { isActiveHost: false }) {
  switch (type) {
    case planTypes.ZOOM_MEETING:
      switch (subType) {
        case BASE_PLAN_SUB_TYPES.ENT:
          return options?.isActiveHost ?
            'billing.zoom_enterprise_active_host.title' :
            'billing.zoom_enterprise_named_host.title';
        default:
          return 'billing.planform.title.zoom_one';
      }
    case planTypes.ZOOM_ROOMS:
      return 'billing.planform.title.zoomroom';
    case planTypes.WEBINAR:
    case planTypes.WEBINAR_PROMO:
      return 'billing.planform.title.webinar';
    case planTypes.ROOM_CONNECTOR:
      return 'billing.rc.title';
    case planTypes.TOLLFREE:
      return isSDK ? 'billing.tollfree.telephony' : 'billing.planform.title.tollfree';
    case planTypes.CMR:
      return 'billing.planform.title.cmr';
    case planTypes.LARGE_MEETING:
      return 'billing.planform.title.large_meeting';
    case planTypes.ZOOM_PHONE:
      return 'billing.planform.title.zoomphone';
    case planTypes.ZOOM_CONTACT_CENTER:
      return 'billing.planform.title.zoom_contact_center';
    case planTypes.PHONE_NUMBER:
      return 'billing.planform.title.phone_number';
    case planTypes.ZOOM_UNITED:
      switch (subType) {
        case BASE_PLAN_SUB_TYPES.PRO:
          return 'billing.zoom_united.pro';
        case BASE_PLAN_SUB_TYPES.BIZ:
          return 'billing.zoom_united.biz';
        default:
          return 'billing.planform.title.zoom_united';
      }
    case planTypes.VIDEO_SDK:
      return 'billing.planform.title.video_sdk';
    case planTypes.ZOOM_HARDWARE:
      return 'billing.planform.title.zoom_hardware';
    case planTypes.HIPAA_COMPLIANCE:
      return window?.$config('baaCountry') == BAA_COUNTRIES.CANADA
        ? 'billing.planform.title.phia_compliance'
        : 'billing.planform.title.hipaa_compliance';
    case planTypes.PAID_DEVELOPER:
      return 'billing.planform.title.paid_developer';
    case planTypes.ZOOM_EVENTS:
    case planTypes.EVENT_SAAS:
      return 'billing.planform.title.zoom_events';
    case planTypes.QSS:
      return 'billing.planform.title.quality_streaming_service';
    case planTypes.ZOOM_NODE:
      return 'billing.planform.title.zoom_node';
    case planTypes.MIO:
      return 'billing.planform.title.mio';
    case planTypes.ZOOM_IQ:
      return 'billing.planform.title.zoom_iq';
    case planTypes.ZOOM_WHITEBOARD:
      return 'billing.planform.title.zoom_whiteboard';
    case planTypes.ZOOM_WHITEBOARD_PLUS:
      return 'billing.planform.title.zoom_whiteboard_plus';
    case planTypes.WORKSPACE_RESERVATION:
      return 'billing.planform.title.workspace_reservation';
    case planTypes.ZOOM_ONE_BUNDLE:
      switch (subType) {
        case BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS:
          return 'billing.planform.title.zoom_one_biz_plus';
        case BASE_PLAN_SUB_TYPES.ZOOM_ONE_ENTERPRISE:
          return 'billing.planform.title.zoom_one_ent';
        case BASE_PLAN_SUB_TYPES.ZOOM_ONE_ENTERPRISE_PLUS:
          return 'billing.planform.title.zoom_one_ent_plus';
        default:
          return 'billing.planform.title.zoom_one';
      }
    case planTypes.ZONE_PRO_PLUS:
      return 'billing.zone_pro_plus.title';
    case planTypes.TRANSLATION_CAPTIONS:
      return 'billing.translation_caption.title';
    case planTypes.VIDEO_SDK_TRANSLATION:
      return 'billing.planform.title.video_sdk_translation';
    case planTypes.ZOOM_ONE:
      return 'billing.planform.title.zoom_one';
    case planTypes.CMK:
      return 'billing.planform.title.cmk';
    case planTypes.ZOOM_MESH:
      return 'billing.planform.title.zoom_mesh';
    case planTypes.ZVA:
      return 'billing.planform.title.zva';
    case planTypes.ZOOM_PHONE$AICONCIERGE:
      return 'billing.planform.title.zoom_phone_ai_concierge';
    case planTypes.ADDITIONAL_HOST:
      return 'billing.planform.title.additional_host';
    case planTypes.ADDITIONAL_CO_EDITOR:
      return 'billing.planform.title.additional_co_editor';
    case planTypes.LDKCMR:
      return 'billing.planform.title.ldk_cmr';
    case planTypes.Bundle_CREDIT:
      return 'billing.planform.title.bundle_credit';
    case planTypes.LDKCRC:
      return 'billing.planform.title.video_sdk_crc';
    case planTypes.EVENT_SAAS_CORE:
      return 'billing.planform.title.eventsaascore';
    case planTypes.API_CSP:
      return 'billing.planform.title.api_csp';
    case planTypes.ZSU:
      return 'billing.planform.title.zsu';
    case planTypes.ZCM:
      return 'billing.zcm.title';
    case planTypes.ZOOM_DOCS:
      return 'billing.zoom_docs.title';
    case planTypes.ZCM_STORAGE:
      return 'billing.zcm_storage.title';
    case planTypes.ZONE_EDU_PLUS:
      return 'billing.zone_edu_plus.title'
    case planTypes.ZOOM_CUSTOM_AI_COMPANION:
      return enableCAICPlanRebranding
        ? 'billing.zoom_custom_ai_companion.rebranding_title'
        : 'billing.zoom_custom_ai_companion.title';
    case planTypes.VIDEO_MANAGEMENT:
      return 'billing.video_management.title'
    default:
      return '';
  }
}

export const getPlanNameKey = ({type, category, isActiveHost}) => {
  if (type === planTypes.ZOOM_UNITED) {
    const pbxCategory = _.chain(category).split("_").get([1], "").upperCase().value();
    return pbxCategory ? `billing.pbx.cart_name.${pbxCategory}` : '';
  }

  if (type === planTypes.ZOOM_ONE) {
    if (category === "zoent") {
      return 'billing.planform.title.zoom_one_ent';
    }
    if (category === "zopent") {
      return 'billing.planform.title.zoom_one_ent_plus';
    }
  }

  if (type === planTypes.ZOOM_ONE_BUNDLE) {
    if (/^zonebizp/i.test(category)) {
      return 'billing.planform.title.zoom_one_biz_plus';
    }

    if(/^zonentst/i.test(category)) {
      return 'billing.planform.title.zoom_one_ent_essentials';
    }
  }

  if (type === planTypes.ZOOM_MEETING) {
    if (category === BASE_PLAN_SUB_TYPES.ENT) {
      if (isActiveHost) {
        return 'billing.zoom_enterprise_active_host.title';
      }
      return 'billing.zoom_enterprise_named_host.title';
    }
     if (category === "zoent") {
      return 'billing.planform.title.zoom_one_ent';
    }

  }

  return "";
}
